import api from './api';

export const getStyleSheet = async () => api.get('/styles-token.json').then((res) => res.data);
